import { render } from "./material-view.vue?vue&type=template&id=dfc3bff2&ts=true"
import script from "./material-view.vue?vue&type=script&lang=ts"
export * from "./material-view.vue?vue&type=script&lang=ts"

import "./material-view.vue?vue&type=style&index=0&id=dfc3bff2&lang=css"

import exportComponent from "C:\\Users\\claus\\source\\repos\\Joni\\SelfService\\JoniSelfService\\JoniSelfServicePortalUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__